import { Icon, LayoutGrid, makeStyles } from '@archer-technologies/ui-components';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';
import * as React from 'react';

const useStyles = makeStyles(() => {
  return {
    checkCellStyles: {
      textAlign: 'center',
      lineHeight: 1
    }
  };
});

const CheckFormatter = ({ value }: DataTypeProvider.ValueFormatterProps) => {
  const { checkCellStyles } = useStyles();
  return (
    value && (
      <LayoutGrid className={checkCellStyles}>
        <Icon icon="Check" fontSize="medium" />
      </LayoutGrid>
    )
  );
};

const CheckTypeProvider = (props: DataTypeProviderProps) => <DataTypeProvider formatterComponent={CheckFormatter} {...props} />;

export { CheckTypeProvider };
